
import axios from 'axios';

const myheaders = {'Accept':'application/json','Content-Type':'application/json',} ;




export const  axios_resiliation_resiliationnomandat= async({lead,datasresil})=>{
    return await axios.post(`/resiliation/resiliationnomandat`,{lead,datasresil}, {headers:myheaders});
}

export const  axios_resiliation_resiliationmail= async({lead,datasresil})=>{
    return await axios.post(`/resiliation/resiliationmail`,{lead,datasresil}, {headers:myheaders});
}

export const  axios_resiliation_resiliationmandat = async({lead,datasresil})=>{
    return await axios.post(`/resiliation/resiliationmandat`,{lead,datasresil}, {headers:myheaders});
}



export const  axios_resiliation_resiliationyesmandat = async({lead,datasresil})=>{
    return await axios.post(`/resiliation/resiliationyesmandat`,{lead,datasresil}, {headers:myheaders});
}
